import { Grid, TextField, TextFieldProps } from "@mui/material";
import {
  Control,
  Controller,
  ControllerProps,
  useFormContext,
} from "react-hook-form";
import React from "react";
import CustomTooltip from "./customTooltip";

export type CustomTextareaAutosizeProps = Omit<TextFieldProps, "name"> & {
  validation?: ControllerProps["rules"];
  name: string;
  toolTipTitle?: string;
  control?: Control<any>;
  readOnly?: boolean;
  autoComplete?: string;
  length?: number;
  label?: string;
};

export default function CustomTextareaAutosize({
  validation = {},
  type,
  required,
  name,
  toolTipTitle,
  readOnly,
  autoComplete,
  length,
  control,
  label,
  onChange,
  ...rest
}: CustomTextareaAutosizeProps): JSX.Element {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={validation}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Grid container alignItems="center">
          <Grid container alignItems="center">
            <Grid
              item
              sx={{
                fontSize: "14px",
                fontFamily:'Poppins',
                fontWeight: "300",
                color:'#797979',
                mb: "4px",
                ml: "4px",
                mr: "6px",
              }}
            >
              {label}
            </Grid>
            {toolTipTitle && <CustomTooltip title={toolTipTitle} />}
          </Grid>

          <TextField
            variant={"outlined"}
            {...rest}
            value={value || ""}
            required={required}
            type={type}
            multiline={true}
            maxRows={4}
            {...register(name)}
            inputProps={{
              maxLength: length ? length : null,
              readOnly: readOnly ? readOnly : false,
              autoComplete: autoComplete ? autoComplete : null,
            }}
            sx={{
              bgcolor: "#ffffff",
              borderRadius: "100px",
              color: "#000000",
              "& .MuiInputLabel-root": {
                color: "#000000", // Label color
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: "100px",
                border: "1px solid transparent",
                fontWeight:200,
                fontSize:'16px',
                "& fieldset": {
                  borderRadius: "100px",
                },
                "&:hover fieldset": {
                  borderColor: "#cccccc", // Hovered border color
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#cccccc", // Focused border color
                },
                "& textarea": {
                  color: "#000000", // Text color inside input
                },
              },
            }}
            error={!!error}
            helperText={error ? error.message : rest?.helperText}
            onChange={(event) => {
              let item: number | string = event.target.value;
              onChange(item);
            }}
          />
        </Grid>
      )}
    />
  );
}
